import { render } from "./productsView.vue?vue&type=template&id=bef9686a&scoped=true"
import script from "./productsView.vue?vue&type=script&lang=js"
export * from "./productsView.vue?vue&type=script&lang=js"

import "./productsView.vue?vue&type=style&index=0&id=bef9686a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef9686a"]])

export default __exports__